// Generated by ServiceInterfaceGenerator Aug 28, 2018 11:02:48 AM
import { sharedReactorWebsocket as ws } from '../reactor.js';

class TenancyServiceInterface {
  constructor() {
    this.service_id = 'tenancyservice-1_3';
  }

  // sends Subscribe to subscribe and Unsubscribe to unsubscribe
  subscribeToActivation(tenancy_id, success_callback, handlers) {
    var subscribe_msg = { service: this.service_id, message: 'Subscribe', data: { topic: '/' + this.service_id + '/tenancy_activation/' + tenancy_id, filter: null } };
    var unsubscribe_msg = { service: this.service_id, message: 'Unsubscribe', data: { topic: '/' + this.service_id + '/tenancy_activation/' + tenancy_id } };
    return ws.subscribeWithHandlers(subscribe_msg, unsubscribe_msg, success_callback, handlers);
  }

  // sends Subscribe to subscribe and Unsubscribe to unsubscribe
  subscribeToAccountInfo(tenancy_id, success_callback, handlers) {
    var subscribe_msg = { service: this.service_id, message: 'Subscribe', data: { topic: '/' + this.service_id + '/account_info/' + tenancy_id, filter: null } };
    var unsubscribe_msg = { service: this.service_id, message: 'Unsubscribe', data: { topic: '/' + this.service_id + '/account_info/' + tenancy_id } };
    return ws.subscribeWithHandlers(subscribe_msg, unsubscribe_msg, success_callback, handlers);
  }

  activateTenancyByURL(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'ActivateTenancyByURLRequest', request, success_callback);
  }

  /**
   * {
   *   url: String
   * }
   */
  getTenancyUrlInfo(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'TenancyUrlInfoRequest', request, success_callback);
  }

  getTenancyEntityId(tenancy_id, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'TenancyEntityRequest', { tenancyId: tenancy_id }, success_callback);
  }

  getTenancyByMatchingUrl(url, limit, offset, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'GetTenanciesByMatchingURLRequest', { tenancyURL: url, limit: limit, offset: offset }, success_callback);
  }

  subscribeToProductLicenseList(app_id, success_callback, handlers) {
    var subscribe_msg = { service: this.service_id, message: 'Subscribe', data: { topic: '/' + this.service_id + '/product_license_list/' + app_id } };
    var unsubscribe_msg = { service: this.service_id, message: 'Unsubscribe', data: { topic: '/' + this.service_id + '/product_license_list/' + app_id } };
    return ws.subscribeWithHandlers(subscribe_msg, unsubscribe_msg, success_callback, handlers);
  }

  urlAvailable(url, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'CheckTenancyUrlAvailableRequest', { tenancyUrl: url }, success_callback);
  }

  regionAwareCreateTenancy(tenancy_name, tenancy_url, app_id, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'RegionAwareCreateTenancyAction', { tenancyName: tenancy_name, tenancyURL: tenancy_url, appId: app_id }, success_callback);
  }
}

export const tenancyService = new TenancyServiceInterface();


//////////////////
// WEBPACK FOOTER
// ../ReactorJSCore/dist/services/tenancyservice.js
// module id = Q1oy
// module chunks = 1 2 3 4